import React, { useEffect, useContext } from "react";
import styles from "./SmartObject.module.scss";
import CurrentContext from "./CurrentContext";
import { Accordion } from "react-bootstrap";

import angus from "../../assets/images/bull/angus.jpg";
import lonestar from "../../assets/images/bull/lonestart.jpg";
import griddleHead from "../../assets/images/bull/griddle_head.jpg";
import brahma from "../../assets/images/bull/brahma.jpg";
import faux_rock from "../../assets/images/bull/faux_rock.jpg";
import quartzite from "../../assets/images/bull/quartzite-misty-gray.png";
import tile from "../../assets/images/bull/tile.jpg";
import double_door from "../../assets/images/bull/double_door.jpg";
import double_door_38 from "../../assets/images/bull/38__double_door.jpg";
import door_combo from "../../assets/images/bull/door_combo.jpg";
import door_drawer_combo from "../../assets/images/bull/door_drawer_combo.jpg";
import door_propane from "../../assets/images/bull/door-door_propane_drawer_combo.jpg";
import door_drawer from "../../assets/images/bull/door_drawer.jpg";
import second_double__drawer from "../../assets/images/bull/second_double__drawer.jpg";
import outdoor_rated_fridge from "../../assets/images/bull/outdoor_rated_fridge.jpg";
import quart_brown from "../../assets/images/bull/quartzite-brown.jpg";
import quart_gray from "../../assets/images/bull/quartzite-gray.jpg";
import faux_gray from "../../assets/images/bull/faux-gray.jpg";
import faux_brown from "../../assets/images/bull/faux-brown.jpg";
import tile_chocolate from "../../assets/images/bull/choclate.jpg";
import tile_civic_sand from "../../assets/images/bull/civic-sand.jpg";
import tile_notable_beige from "../../assets/images/bull/notable-beige.jpg";
import tile_park_lane_grey from "../../assets/images/bull/park-lane-grey.jpg";
import tile_union_smoke from "../../assets/images/bull/union-smoke.jpg";
import tile_iron_grey from "../../assets/images/bull/iron-grey.jpg";
import umberella_hole from "../../assets/images/bull/umberella_hole.png";
import no_umberella_hole from "../../assets/images/bull/without_umbrellaHole.png";
import bottle_opener from "../../assets/images/bull/bottle_opener.jpg";
import no_bottle_opener from "../../assets/images/bull/without_bottle_opener.png";
import quart_sandstone_stone from "../../assets/images/bull/quartzite-sandstone-tan.jpg";
import quart_misty_gray from "../../assets/images/bull/quartzite-misty-gray.png";
import no_siding from "../../assets/images/bull/no-siding-1k.jpeg";
import refridgerator_img from "../../assets/images/bull/refridgerator.png";
import sideburner_img from "../../assets/images/bull/side_burnur.jpg";
import sink_img from "../../assets/images/bull/sink.jpg";
import standard_fridge from "../../assets/images/bull/standard_fridge.jpg";
import none_img from "../../assets/images/bull/none.jpg";
import trash_drawer from "../../assets/images/bull/trash_drawer.jpg";
import verticle_access_door from "../../assets/images/bull/verticle_access_door.jpg";
import { useParams } from "react-router-dom";
// Reusable Button Component
const SelectionOptions = ({ label, onClick, isActive, thumb, hide }) => (
  <div
    className={`${styles.selectionButtons} ${isActive ? styles.active : ""}`}
    onClick={onClick}
    style={{ display: hide ? "none" : "flex" }}
  >
    <img src={thumb} alt={label} />
    <div className={styles.textContainer} title={label}>
      <div className={styles.tilename}>{label}</div>
    </div>
  </div>
);

const OptionPanel = () => {
  const { modelId } = useParams();
  const {
    grill,
    setGrill,
    siding,
    setSiding,
    door,
    setDoor,
    secondDoor,
    setSecondDoor,
    sink,
    setSink,
    colorScheme,
    setcolorScheme,
    umbrellHole,
    setUmbrellHole,
    bottleOpener,
    setBottleOpener,
    sideBurner,
    setSideBurner,
    refrigerator,
    setRefrigerator,
    refrigeratorType,
    setRefrigeratorType,
    tileColorScheme,
    setTileColorScheme,
    setLoading,
  } = useContext(CurrentContext);

  useEffect(() => {
    if (modelId === "1") {
      setGrill('30" Angus');
      setSiding("Faux Rock");
      setcolorScheme("Brown");
      setTileColorScheme("Civic Sand");
      setDoor('30" Door/Drawer Combo');
      setUmbrellHole(false);
      setBottleOpener(false);
    } else if (modelId === "2" || modelId === "5") {
      setGrill('30" Angus');
      setSiding("Quartzite");
      setcolorScheme("Misty Gray SR16");
      setTileColorScheme("Union smoke");
      setDoor('30" Door/Drawer Combo');
      setSecondDoor("Trash Drawer");
      setRefrigeratorType("Outdoor Rated Fridge");
      setSink(false);
      setUmbrellHole(false);
      setBottleOpener(false);
    } else if (modelId === "3") {
      setGrill('30" Angus');
      setSiding("Quartzite");
      setcolorScheme("Sandstone Tan SR12");
      setTileColorScheme("Chocolate");
      setDoor('30" Door/Drawer Combo');
      setRefrigeratorType("Outdoor Rated Fridge");
      setSink(false);
      setUmbrellHole(false);
      setBottleOpener(false);
    } else {
      setGrill('38" Brahma');
      setSiding("Faux Rock");
      setcolorScheme("Gray");
      setTileColorScheme("Union smoke");
      setDoor('30" Double Door');
      setRefrigeratorType("Standard Fridge");
      setSink(true);
      setUmbrellHole(false);
      setBottleOpener(false);
    }
  }, []);

  const options = [
    {
      title: "Grill",
      values: [
        {
          label: '30" Angus',
          onClick: () => {
            setGrill('30" Angus');
            if (modelId === "3" || modelId === "2" || modelId === "5") {
              setDoor('30" Double Door');
            }
          },
          selectedValue: grill,
          thumb: angus,
          hide: modelId === "4" ? true : false,
        },
        {
          label: '30" Lonestar',
          onClick: () => {
            setGrill('30" Lonestar');
            if (modelId === "3" || modelId === "2" || modelId === "5") {
              setDoor('30" Double Door');
            }
          },
          selectedValue: grill,
          thumb: lonestar,
          hide: modelId === "4" ? true : false,
        },
        {
          label: '30" Bull Griddle Head',
          onClick: () => {
            setGrill('30" Bull Griddle Head');
            if (modelId === "3" || modelId === "2" || modelId === "5") {
              setDoor('30" Double Door');
            }
          },
          selectedValue: grill,
          thumb: griddleHead,
          hide: modelId === "4" ? true : false,
        },
        {
          label: '38" Brahma',
          onClick: () => setGrill('38" Brahma'),
          selectedValue: grill,
          thumb: brahma,
          hide: modelId === "2" || modelId === "5" || modelId === "4" ? false : true,
        },
      ],
    },
    {
      title: "Countertop Tile",
      values: [
        {
          label: "Chocolate",
          onClick: () => setTileColorScheme("Chocolate"),
          selectedValue: tileColorScheme,
          thumb: tile_chocolate,
        },
        {
          label: "Civic Sand",
          onClick: () => setTileColorScheme("Civic Sand"),
          selectedValue: tileColorScheme,
          thumb: tile_civic_sand,
        },
        {
          label: "Notable beige",
          onClick: () => setTileColorScheme("Notable beige"),
          selectedValue: tileColorScheme,
          thumb: tile_notable_beige,
        },
        {
          label: "Park Lane Gray",
          onClick: () => setTileColorScheme("Park Lane Gray"),
          selectedValue: tileColorScheme,
          thumb: tile_park_lane_grey,
        },
        {
          label: "Union smoke",
          onClick: () => setTileColorScheme("Union smoke"),
          selectedValue: tileColorScheme,
          thumb: tile_union_smoke,
        },
        {
          label: "Iron Gray",
          onClick: () => setTileColorScheme("Iron Gray"),
          selectedValue: tileColorScheme,
          thumb: tile_iron_grey,
        },
        {
          label: "No Tile",
          onClick: () => setTileColorScheme("No Tile"),
          selectedValue: tileColorScheme,
          thumb: no_siding,
        },
      ],
    },
    {
      title: "Base Material Options",
      values: [
        {
          label: "Quartzite",
          onClick: () => {
            setSiding("Quartzite");
            setcolorScheme("Sandstone Tan SR12");
            // setRefrigerator(true);
          },
          selectedValue: siding,
          thumb: quartzite,
        },
        {
          label: "Faux Rock",
          onClick: () => {
            setSiding("Faux Rock");
            setcolorScheme("Gray");
            // setRefrigerator(true);
            if (modelId === "3" || modelId === "4") {
              setRefrigeratorType("Standard Fridge");
              setDoor('30" Double Door');
            }
            if (modelId === "1") {
              setRefrigeratorType("Standard Fridge");
            }
          },
          selectedValue: siding,
          thumb: faux_rock,
          hide: modelId === "2" || modelId === "5" ? true : false,
        },
        {
          label: "No Siding",
          onClick: () => {
            setSiding("No Siding");
            // setSiding((prev)=> (...prev))
            setcolorScheme("No Siding");
          },
          selectedValue: siding,
          thumb: no_siding,
          hide: false,
        },
      ],
    },
    {
      title: "Color",
      values: [
        {
          label: "Gray",
          onClick: () => setcolorScheme("Gray"),
          selectedValue: colorScheme,
          thumb: faux_gray,
          hide: siding === "Faux Rock" ? false : true,
        },
        {
          label: "Brown",
          onClick: () => setcolorScheme("Brown"),
          selectedValue: colorScheme,
          thumb: faux_brown,
          hide: siding === "Faux Rock" ? false : true,
        },
        {
          label: "Sandstone Tan SR12",
          onClick: () => setcolorScheme("Sandstone Tan SR12"),
          selectedValue: colorScheme,
          thumb: quart_sandstone_stone,
          hide: siding === "Quartzite" ? false : true,
        },
        {
          label: "Misty Gray SR16",
          onClick: () => setcolorScheme("Misty Gray SR16"),
          selectedValue: colorScheme,
          thumb: quart_misty_gray,
          hide: siding === "Quartzite" ? false : true,
        },
        {
          label: "No Siding",
          onClick: () => setcolorScheme("No Siding"),
          selectedValue: colorScheme,
          thumb: no_siding,
          hide: siding === "No Siding" ? false : true,
        },
      ],
    },
    {
      title: "Door/Drawer",
      values: [
        {
          label: '30" Double Door',
          onClick: () => setDoor('30" Double Door'),
          selectedValue: door,
          thumb: double_door,
        },
        {
          label: '30" Door/Drawer Combo',
          onClick: () => setDoor('30" Door/Drawer Combo'),
          selectedValue: door,
          thumb: door_combo,
        },
        {
          label: '30" Door/Propane Drawer Combo',
          onClick: () => setDoor('30" Door/Propane Drawer Combo'),
          selectedValue: door,
          thumb: door_propane,
        },
        {
          label: '38" Double Door',
          onClick: () => setDoor('38" Double Door'),
          selectedValue: door,
          thumb: double_door_38,
          hide:
            (modelId === "2" || modelId === "5" || modelId === "4") &&
            grill === '38" Brahma' &&
            siding === "Quartzite"
              ? false
              : true,
        },
        {
          label: '38" Door/Drawer Combo',
          onClick: () => setDoor('38" Door/Drawer Combo'),
          selectedValue: door,
          thumb: door_drawer_combo,
          hide:
            (modelId === "2" || modelId === "5" || modelId === "4") &&
            grill === '38" Brahma' &&
            siding === "Quartzite"
              ? false
              : true,
        },
      ],
    },
    {
      title: "Second Door/Drawer",
      hide: modelId === "2" || modelId === "5" ? false : true,
      values: [
        {
          label: "Vertical Access Door",
          onClick: () => setSecondDoor("Vertical Access Door"),
          selectedValue: secondDoor,
          thumb: verticle_access_door,
        },
        {
          label: "Double Drawer",
          onClick: () => setSecondDoor("Double Drawer"),
          selectedValue: secondDoor,
          thumb: second_double__drawer,
        },
        {
          label: "Trash Drawer",
          onClick: () => setSecondDoor("Trash Drawer"),
          selectedValue: secondDoor,
          thumb: trash_drawer,
        },
        {
          label: "No Door",
          onClick: () => setSecondDoor("No Door"),
          selectedValue: secondDoor,
          thumb: none_img,
        },
      ],
    },
    {
      title: "Refrigeration Options",
      // hide: modelId === "2" || modelId === "3" ? false : true,
      values: [
        {
          label: "Standard Fridge",
          onClick: () => setRefrigeratorType("Standard Fridge"),
          selectedValue: refrigeratorType,
          thumb: standard_fridge,
        },
        {
          label: "Outdoor Rated Fridge",
          onClick: () => setRefrigeratorType("Outdoor Rated Fridge"),
          selectedValue: refrigeratorType,
          thumb: outdoor_rated_fridge,
          hide:
            (siding === "Faux Rock" && (modelId === "1" || modelId === "3" || modelId === "4")) ||
            // modelId === "1" ||
            modelId === "2" || modelId === "5"
              ? true
              : false,
        },
        {
          label: "Outdoor Rated Fridge",
          onClick: () => setRefrigeratorType("Outdoor Rated Fridge"),
          selectedValue: refrigeratorType,
          thumb: outdoor_rated_fridge,
          hide:
            (siding === "Faux Rock" && (modelId === "1" || modelId === "3" || modelId === "4")) ||
            modelId === "1" ||
            modelId === "3" ||
            modelId === "4"
              ? true
              : false,
        },
        {
          label: "None",
          onClick: () => setRefrigeratorType("None"),
          selectedValue: refrigeratorType,
          hide:
            siding === "Faux Rock" && (modelId === "3" || modelId === "4")
              ? // ||
                // modelId === '1'
                true
              : false,
          thumb: none_img,
        },
      ],
    },
  ];

  const getSelectedOption = (option) => {
    const selectedOption = option.values.find(
      (v) => v.label === v.selectedValue
    );
    return selectedOption;
  };

  return (
    <div>
      <div
        className={styles.tilename}
        style={{
          padding: "5px",
          fontWeight: 700,
        }}
      >
        <span>Product Name : </span>
        <span>
          {modelId === "1"
            ? "San Juan"
            : modelId === "2"
            ? "Camano"
            : modelId === "3"
            ? "Samish"
            : modelId === "4"
            ? "Guemes"
            : modelId === "5"
            ? "Camano Updated"
            : null}
        </span>
      </div>
      <Accordion>
        {options.map((option, index) => {
          const { label, thumb } = getSelectedOption(option);
          return (
            <Accordion.Item
              eventKey={index}
              key={index}
              style={{ display: option.hide ? "none" : "block" }}
            >
              <Accordion.Header>
                <div className={styles.labelOption}>
                  <div className={styles.imgContainer}>
                    {thumb ? (
                      <img src={thumb} height={40} width={40} alt={label} />
                    ) : (
                      <div
                        style={{
                          height: "40px",
                          width: "40px",
                          backgroundColor: "#ccc",
                        }}
                      />
                    )}
                  </div>
                  <div className={styles.textContainer}>
                    <div style={{ display: "block" }}>
                      <div
                        className={styles.subHead}
                        style={{ fontSize: 14, fontWeight: 500 }}
                      >
                        {option.title}
                      </div>
                      <div
                        className={styles.heading}
                        style={{ fontSize: 11, textAlign: "left" }}
                      >
                        {label !== "None" ? label : "Select an option"}
                      </div>
                    </div>
                  </div>
                </div>
              </Accordion.Header>
              <Accordion.Body>
                <div className={styles.accordianBody}>
                  {option.values.map((button, idx) => (
                    <SelectionOptions
                      key={idx}
                      label={button.label}
                      thumb={button.thumb}
                      onClick={button.onClick}
                      isActive={button.selectedValue === button.label}
                      hide={button.hide}
                    />
                  ))}
                </div>
              </Accordion.Body>
            </Accordion.Item>
          );
        })}
        <Accordion.Item eventKey={7} key={7}>
          <Accordion.Header>
            <div className={styles.labelOption}>
              <div className={styles.imgContainer}>
                <img
                  src={no_umberella_hole}
                  height={40}
                  width={40}
                  alt="miscellaneous"
                />
              </div>
              <div className={styles.textContainer}>
                <div style={{ display: "block" }}>
                  <div
                    className={styles.subHead}
                    style={{ fontSize: 14, fontWeight: 500 }}
                  >
                    Miscellaneous
                  </div>
                </div>
              </div>
            </div>
          </Accordion.Header>
          <Accordion.Body>
            <div className={styles.accordianBody}>
              <div
                className={`${styles.selectionButtons} ${
                  umbrellHole ? styles.active : ""
                }`}
                style={{ height: 70, width: 70, marginBottom: 10 }}
                onClick={() => setUmbrellHole(!umbrellHole)}
              >
                <img
                  src={umbrellHole ? umberella_hole : no_umberella_hole}
                  alt="umberella"
                />
              </div>
              <div>
                <div style={{ fontSize: 14, fontWeight: 500 }}>
                  Umberella hole
                </div>
                <div style={{ fontSize: 11, textAlign: "left" }}>
                  {umbrellHole ? "Selected" : "Not Selected"}
                </div>
              </div>
            </div>
            {siding === "Quartzite" && (
              <div className={styles.accordianBody}>
                <div
                  className={`${styles.selectionButtons} ${
                    bottleOpener ? styles.active : ""
                  }`}
                  style={{
                    height: 70,
                    width: 70,
                    marginBottom: 10,
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                  onClick={() => setBottleOpener(!bottleOpener)}
                >
                  <img
                    src={bottleOpener ? bottle_opener : no_bottle_opener}
                    alt="bottle opener"
                    style={{ height: 70, width: 40 }}
                  />
                </div>
                <div>
                  <div style={{ fontSize: 14, fontWeight: 500 }}>
                    Bottle Opener
                  </div>
                  <div style={{ fontSize: 11, textAlign: "left" }}>
                    {bottleOpener ? "Selected" : "Not Selected"}
                  </div>
                </div>
              </div>
            )}
            <div className={styles.accordianBody}>
              <div
                className={`${styles.selectionButtons} ${
                  sideBurner ? styles.active : ""
                }`}
                style={{
                  height: 70,
                  width: 70,
                  marginBottom: 10,
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
                onClick={() => setSideBurner(!sideBurner)}
              >
                <img
                  src={sideBurner ? sideburner_img : no_bottle_opener}
                  alt="Side burner"
                  style={{ height: 70, width: 40 }}
                />
              </div>
              <div>
                <div style={{ fontSize: 14, fontWeight: 500 }}>Side Burner</div>
                <div style={{ fontSize: 11, textAlign: "left" }}>
                  {sideBurner ? "Selected" : "Not Selected"}
                </div>
              </div>
            </div>
            {/* {(siding === "Quartzite" && modelId === "1") ||
            siding === "Quartzite" && modelId === "2" ||
            siding === "Quartzite" && modelId === "3" ? (
              <div className={styles.accordianBody}>
                <div
                  className={`${styles.selectionButtons} ${
                    refrigerator ? styles.active : ""
                  }`}
                  style={{
                    height: 70,
                    width: 70,
                    marginBottom: 10,
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                  onClick={() => setRefrigerator(!refrigerator)}
                >
                  <img
                    src={refrigerator ? refridgerator_img : no_bottle_opener}
                    alt="Refrigerator"
                    style={{ height: 70, width: 40 }}
                  />
                </div>
                <div>
                  <div style={{ fontSize: 14, fontWeight: 500 }}>
                    Refrigerator
                  </div>
                  <div style={{ fontSize: 11, textAlign: "left" }}>
                    {refrigerator ? "Selected" : "Not Selected"}
                  </div>
                </div>
              </div>
            ) : null} */}
            {(modelId === "2" || modelId === "5" || modelId === "3" || modelId === "4") && (
              <div className={styles.accordianBody}>
                <div
                  className={`${styles.selectionButtons} ${
                    sink ? styles.active : ""
                  }`}
                  style={{
                    height: 70,
                    width: 70,
                    marginBottom: 10,
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                  onClick={() => setSink(!sink)}
                >
                  <img
                    src={sink ? sink_img : no_bottle_opener}
                    alt="sink"
                    style={{ height: 70, width: 40 }}
                  />
                </div>
                <div>
                  <div style={{ fontSize: 14, fontWeight: 500 }}>Sink</div>
                  <div style={{ fontSize: 11, textAlign: "left" }}>
                    {sink ? "Selected" : "Not Selected"}
                  </div>
                </div>
              </div>
            )}
          </Accordion.Body>
        </Accordion.Item>
      </Accordion>
    </div>
  );
};

export default OptionPanel;
